import React, { useContext, useState, useRef } from 'react';

import Layout from '../../common_components/Layout';
import InnerModal from '../components/InnerModal';
import { AppContext } from '../contexts';
import { getNextStep, getStepsFurtherThan } from '../utils';

export default function DataImport({ data, name, isCompleted }) {
  const app = useContext(AppContext);
  const stepsApi = app.APIs.steps;

  const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);
  const formRef = useRef(null);

  const handleFormSubmit = (event) => {
    event.preventDefault();
    if (isCompleted) {
      setIsWarningModalOpen(true);
    } else {
      submitStepData(event.target, null);
    }
  };
  const submitStepData = (formElement, stepsToReset) => {
    var data = new FormData(formElement);

    stepsApi
      .importData(app.activeProject.id, data, stepsToReset)
      .then((data) => {
        app.setActiveProject(data);
        app.setVisibleStep(getNextStep(name));
      });
  };

  const exampleValues = [
    {
      date: '2011-01-01 08:00:00',
      conc: 38,
      blh: 546.7,
      ws: 7,
      wd: 241,
      tt: -1.1,
      rh: 75,
      pres: 983.8,
      tskc: 5,
      ssrd: 1.1,
    },
    {
      date: '2011-01-01 09:00:00',
      conc: 38,
      blh: 576.7,
      ws: 8,
      wd: 244,
      tt: -1.1,
      rh: 74,
      pres: 983.4,
      tskc: 5,
      ssrd: 33.8,
    },
    {
      date: '2011-01-01 10:00:00',
      conc: 49,
      blh: 626.6,
      ws: 9,
      wd: 251,
      tt: -1.1,
      rh: 75,
      pres: 982.8,
      tskc: 2,
      ssrd: 119.0,
    },
    {
      date: '2011-01-01 11:00:00',
      conc: 47,
      blh: 635.4,
      ws: 9,
      wd: 244,
      tt: -0.4,
      rh: 72,
      pres: 982.2,
      tskc: 4,
      ssrd: 191.8,
    },
  ];
  const exampleColumns = Object.keys(exampleValues[0]);
  const stepsFurtherThenCurrent = getStepsFurtherThan(name);

  return (
    <Layout
      overflow={'overflow-y-auto'}
      sideContent={
        <>
          <form
            onSubmit={handleFormSubmit}
            className="overflow-y-auto h-full max-h-full [&>*:last-child]:mb-0"
            ref={formRef}
          >
            <h2 className="text-white">Stacja</h2>
            <label className="form-control w-full max-w-xs">
              <div className="label">
                <span className="label-text text-sm text-white">Nazwa *</span>
              </div>
              <input
                type="text"
                name="stationname"
                className="input input-xs input-bordered w-full max-w-xs text-black"
                defaultValue={data?.stationname}
                required
              />
            </label>
            <label className="form-control w-full max-w-xs">
              <div className="label">
                <span className="label-text text-sm text-white">Kod *</span>
              </div>
              <input
                type="text"
                name="stationcode"
                className="input input-xs input-bordered w-full max-w-xs text-black"
                defaultValue={data?.stationcode}
                required
              />
            </label>
            <h2 className="text-white" id="datafile-label">
              Dane *
            </h2>
            <input
              type="file"
              name="datafile"
              className="file-input file-input-xs file-input-bordered w-full max-w-xs text-black"
              accept=".csv, application/vnd.ms-excel, .xlsx"
              required={!app.activeProject.datafile}
              aria-labelledby="datafile-label"
            />
            {app.activeProject.datafile && (
              <p
                htmlFor="datafile"
                className="mt-2 text-sm line-clamp-2 text-ellipsis"
              >
                Zapisana wartość: {app.activeProject.datafile}
              </p>
            )}
            <div>
              <h2 className="text-white">Substancja</h2>
              <label className="form-control w-full max-w-xs">
                <div className="label">
                  <span className="label-text text-sm text-white">Skrót *</span>
                </div>
                <input
                  type="text"
                  name="substancenameshort"
                  className="input input-xs input-bordered w-full max-w-xs text-black"
                  defaultValue={data?.substancenameshort}
                  required
                />
              </label>
              <label className="form-control w-full max-w-xs">
                <div className="label">
                  <span className="label-text text-sm text-white">Nazwa *</span>
                </div>
                <input
                  type="text"
                  name="substancename"
                  className="input input-xs input-bordered w-full max-w-xs text-black"
                  defaultValue={data?.substancename}
                  required
                />
              </label>
              <label className="form-control w-full max-w-xs">
                <div className="label">
                  <span className="label-text text-sm text-white">
                    Jednostka *
                  </span>
                </div>
                <select
                  className="select select-xs select-bordered w-full max-w-xs text-black"
                  name="substanceunit"
                  defaultValue={data?.substanceunit}
                  required
                  aria-label="Wybierz jednostkę substancji"
                >
                  <option>mg/m3</option>
                  <option value="ug/m3">&#181;g/m3</option>
                  <option>ng/m3</option>
                  <option>pg/m3</option>
                  <option>fg/m3</option>
                </select>
              </label>
              <div className="mt-8">
                <p className="text-white text-xs text-right mb-2 opacity-80">
                  * - pole wymagane
                </p>
                <div className="flex justify-end">
                  <button type="submit" className="btn btn-success">
                    Kontynuuj
                  </button>
                </div>
              </div>
            </div>
          </form>
        </>
      }
      title="Wprowadź dane wejściowe modelu"
      mainContent={
        <>
          <div className="flex flex-col max-w-full">
            <h2>Przykładowe dane</h2>
            <div className="overflow-x-auto">
              <table className="table table-sm table-auto [&_th]:whitespace-nowrap [&_td]:whitespace-nowrap ">
                <thead>
                  <tr>
                    {exampleColumns.map((column, i) => (
                      <th key={column + i}>{column}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {exampleValues.map((row, i) => (
                    <tr key={row + i}>
                      {exampleColumns.map((column, i) => (
                        <td key={column + i}>{row[column]}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="px-auto">
              <h3>Proszę zwrócić uwagę na:</h3>
              <ol>
                <li>
                  Nazwy zmiennych - zakładamy, że nazwy zmiennych zawsze będą
                  takie same jak w przykładowym pliku. Jeśli zostaną wprowadzone
                  własne skrócone nazwy nagłówków program nie będzie mógł ich
                  zidentyfikować.
                </li>
                <li>
                  Formatowanie braków danych:
                  <ol className="alpha-lower-numering">
                    <li>"" - wartość pusta (domyślnie)</li>
                    <li>NA - not a number</li>
                    <li>
                      Można zdefiniować własne oznaczenie braków danych, ale
                      musi być jednorodne dla wszystkich zmiennych dostępnych w
                      zestawie danych
                    </li>
                  </ol>
                </li>
              </ol>
            </div>
          </div>
          {isWarningModalOpen && (
            <InnerModal>
              <FormSubmitWarningAlert
                setIsOpen={setIsWarningModalOpen}
                submitStepData={() =>
                  submitStepData(formRef.current, stepsFurtherThenCurrent)
                }
              ></FormSubmitWarningAlert>
            </InnerModal>
          )}
        </>
      }
    ></Layout>
  );
}

function FormSubmitWarningAlert({ setIsOpen, submitStepData }) {
  const handleCancelBtn = () => {
    setIsOpen(false);
  };
  const handleContinueBtn = () => {
    setIsOpen(false);
    submitStepData();
  };

  return (
    <div className="flex flex-col w-full h-full">
      <h2 className="mt-2">
        Spowoduje to usuniecie następnych kroków i uzupełnionych w nich danych.
      </h2>
      <p className="mb-8">Czy chcesz kontynuować?</p>
      <div className="flex justify-between">
        <button onClick={handleCancelBtn} className="btn">
          Anuluj
        </button>
        <button onClick={handleContinueBtn} className="btn btn-warning">
          Kontynuuj
        </button>
      </div>
    </div>
  );
}
